import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

export const FETCH_HOMEWORK_CONTENT_TYPES_REQUEST = 'FETCH_HOMEWORK_CONTENT_TYPES_REQUEST';
export const FETCH_HOMEWORK_CONTENT_TYPES_SUCCESS = 'FETCH_HOMEWORK_CONTENT_TYPES_SUCCESS';
export const FETCH_HOMEWORK_CONTENT_TYPES_FAILURE = 'FETCH_HOMEWORK_CONTENT_TYPES_FAILURE';

const buildTypesUrl = (courseTypeId) => buildUrl(`/course-type-levels/${courseTypeId}/homework-types`);

export function fetchTypesIfNeeded(courseTypeLevelId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildTypesUrl(courseTypeLevelId) })) {
      return false;
    }

    return dispatch(fetchTypes(courseTypeLevelId));
  };
}

export function fetchTypes(courseTypeLevelId) {
  return (dispatch) => {
    const url = buildTypesUrl(courseTypeLevelId);
    const method = 'GET';

    const promise = dispatch(fetchTypesRequest()).payload
      .then((response) => dispatch(fetchTypesSuccess(response)))
      .catch((error) => dispatch(fetchTypesFailure(error)));

    function fetchTypesRequest() {
      return ApiCall.createAction({
        type: FETCH_HOMEWORK_CONTENT_TYPES_REQUEST,
        payload: fetch(url),
        url,
        method,
        courseTypeLevelId,
      });
    }

    function fetchTypesSuccess(payload) {
      return ApiCall.createAction({
        type: FETCH_HOMEWORK_CONTENT_TYPES_SUCCESS,
        payload,
        url,
        method,
        courseTypeLevelId,
      });
    }

    function fetchTypesFailure(error) {
      return ApiCall.createAction({
        type: FETCH_HOMEWORK_CONTENT_TYPES_FAILURE,
        error,
        url,
        method,
        courseTypeLevelId,
      });
    }

    return promise;
  };
}



// WEBPACK FOOTER //
// ./data/Homework/Types/actions.js